import { z } from 'zod';
import { api } from '@/lib/api';
import {
  ActivityInboxResponseSchema,
  LastSeenResponseSchema,
  type ActivityInboxResponse,
  type LastSeenResponse,
} from './schemas';

function tenantHeaders(tenantId: string): Record<string, string> {
  return { 'X-Tenant-Id': tenantId };
}

const VoidSchema = z.void();

export interface ActivityFetchOpts {
  scope?: 'mine' | 'team';
  window?: '48h' | '7d' | '30d' | 'all';
  statuses?: string[];
  memberIds?: string[];
  templateIds?: string[];
}

export async function getActivityInbox(
  tenantId: string,
  opts: ActivityFetchOpts = {},
): Promise<ActivityInboxResponse> {
  const filters: string[] = [];
  if (opts.scope) filters.push(`scope:${opts.scope}`);
  if (opts.window) filters.push(`window:${opts.window}`);
  for (const s of opts.statuses ?? []) filters.push(`status:${s}`);
  for (const m of opts.memberIds ?? []) filters.push(`member:${m}`);
  for (const t of opts.templateIds ?? []) filters.push(`template:${t}`);
  const query = filters.map((f) => `filter=${encodeURIComponent(f)}`).join('&');
  const path = query ? `/tenant/activity?${query}` : '/tenant/activity';
  return api.get(path, ActivityInboxResponseSchema, { headers: tenantHeaders(tenantId) });
}

export async function getActivityLastSeen(tenantId: string): Promise<LastSeenResponse> {
  return api.get('/tenant/activity/last-seen', LastSeenResponseSchema, {
    headers: tenantHeaders(tenantId),
  });
}

export async function setActivityLastSeen(
  tenantId: string,
  activityLastSeenAt?: string,
): Promise<void> {
  await api.post(
    '/tenant/activity/last-seen',
    VoidSchema,
    activityLastSeenAt ? { activity_last_seen_at: activityLastSeenAt } : {},
    { headers: tenantHeaders(tenantId) },
  );
}
